import { createFileRoute } from "@tanstack/react-router";
import Emails from "../../pages/admin/Emails";

export const Route = createFileRoute("/admin/emails")({
  component: Emails,
});
